export default __webpack_public_path__ + "static/media/ic-art-running-flag.ac929df2.svg";